/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrintingQueueIdsDto
 */
export interface PrintingQueueIdsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof PrintingQueueIdsDto
     */
    idsprintingQueue?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PrintingQueueIdsDto
     */
    idsfichier?: Array<number> | null;
}

/**
 * Check if a given object implements the PrintingQueueIdsDto interface.
 */
export function instanceOfPrintingQueueIdsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrintingQueueIdsDtoFromJSON(json: any): PrintingQueueIdsDto {
    return PrintingQueueIdsDtoFromJSONTyped(json, false);
}

export function PrintingQueueIdsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrintingQueueIdsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsprintingQueue': !exists(json, 'idsprintingQueue') ? undefined : json['idsprintingQueue'],
        'idsfichier': !exists(json, 'idsfichier') ? undefined : json['idsfichier'],
    };
}

export function PrintingQueueIdsDtoToJSON(value?: PrintingQueueIdsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsprintingQueue': value.idsprintingQueue,
        'idsfichier': value.idsfichier,
    };
}

